export const ALERT_TYPES = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
} as const;

export type AlertType = (typeof ALERT_TYPES)[keyof typeof ALERT_TYPES];

export const ALERT_POSITIONS = {
    TOP_LEFT: 'top-left',
    TOP_CENTER: 'top-center',
    TOP_RIGHT: 'top-right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_RIGHT: 'bottom-right',
} as const;

export type AlertPosition = (typeof ALERT_POSITIONS)[keyof typeof ALERT_POSITIONS];

export const ALERT_ANIMATIONS = {
    FADE: 'fade',
    SLIDE_DOWN: 'slide-down',
    SLIDE_UP: 'slide-up',
    SLIDE_LEFT: 'slide-left',
    SLIDE_RIGHT: 'slide-right',
    ZOOM: 'zoom',
    BOUNCE: 'bounce',
    FLIP: 'flip',
} as const;

export type AlertAnimation = (typeof ALERT_ANIMATIONS)[keyof typeof ALERT_ANIMATIONS];

export const ALERT_VARIANTS = {
    FLOATING: 'floating',
    INLINE: 'inline',
} as const;

export type AlertVariant = (typeof ALERT_VARIANTS)[keyof typeof ALERT_VARIANTS];
